import axios from "axios";
import _, { toLower } from "lodash";
import Vue from "vue";
import Vuex from "vuex";
import { paginate } from "../helpers/helpers";

Vue.use(Vuex);

export const store = new Vuex.Store({
    strict: false,
    state: {
        DEFAULT_PAGE_SIZE: 6,
        current_page: 1,
        isDataLoaded: false,
        jobs: [],
        current_country: "",
        office: "",
        department: "",
        search_query: "",

        url:
            "https://boards-api.greenhouse.io/v1/boards/berlinbrands/jobs?content=true"
    },
    mutations: {
        create_jobs_object(state, data) {
            data.forEach(item => {
                let job = {
                    id: item.id,
                    position: item.title,
                    department: item.departments[0].name,
                    office: item.location.name,
                    url: item.absolute_url
                };
                state.jobs.push(job);
            });
            state.isDataLoaded = true;
        },

        move_page(state, page) {
            state.current_page = page;
        },

        set_department(state, new_value) {
            state.department = new_value;
        },
        set_office(state, new_value) {
            state.office = new_value;
        },
        set_search_query(state, new_value) {
            state.search_query = new_value;
        },
        set_office_based_on_country(state) {
            let url_parts = _.split(window.location.pathname, "/");
            let country = url_parts[3];
            if (!country) return;
            if (country.includes("germany")) {
                state.office = "Berlin, Germany";
                return;
            }
            if (country.includes("slovakia")) {
                state.office = "Bratislava, Slovakia";
                return;
            }
        }
    },
    actions: {
        async load_jobs({ state, commit }) {
            axios.get(state.url).then(response => {
                commit("create_jobs_object", response.data.jobs);
            });
        }
    },
    getters: {
        paginated_jobs: (state, getters) => {
            return paginate(
                getters.filtered_jobs,
                state.DEFAULT_PAGE_SIZE,
                state.current_page
            );
        },
        get_office: state => {
            return state.office;
        },
        filtered_jobs: (state, commit) => {
            /**Najprv sa vyfiltrujú joby, zo searchu **/
            let filtered_jobs = _.filter(state.jobs, job => {
                return (
                    _.includes(
                        _.toLower(job.office),
                        _.toLower(state.search_query)
                    ) ||
                    _.includes(
                        _.toLower(job.department),
                        _.toLower(state.search_query)
                    ) ||
                    _.includes(
                        _.toLower(job.position),
                        _.toLower(state.search_query)
                    )
                );
            });
            /**Potom sa filtrujú výberom zo select boxov **/
            filtered_jobs = _.filter(filtered_jobs, job => {
                return (
                    _.includes(job.office, state.office) &&
                    _.includes(job.department, state.department)
                );
            });
            /** Zakaždým sa resetuje paginácia na page 1 */
            state.current_page = 1;
            /** */
            return filtered_jobs;
        },
        getOffices: state => {
            let offices = [];
            _.forEach(state.jobs, job => {
                offices.push(job.office);
            });
            offices = _.uniq(offices);
            return offices;
        },
        getDepartments: state => {
            let departments = [];
            _.forEach(state.jobs, job => {
                departments.push(job.department);
            });
            departments = _.uniq(departments);
            return departments;
        }
    }
});
